import { Component, OnInit, Input, Output } from '@angular/core';
import {EventEmitter} from '@angular/core';
import { PlayersService } from "../../services/players.service";
import { TournamentService } from "../../services/tournament.service";
import { DuelSeriesService } from "../../services/duel-series.service";

@Component({
  selector: 'app-player-video-modal',
  templateUrl: './player-video-modal.component.html',
  styleUrls: ['./player-video-modal.component.scss']
})
export class PlayerVideoModalComponent implements OnInit {

  @Input() playerData;
  @Output() outputClickOnBack: EventEmitter<any> = new EventEmitter();

  private _duelsWithVideoByTournaments;
  private _tournamentsName = {};
  private _duelsInfo = {};

  constructor(
    private playersService: PlayersService,
    private tournamentService: TournamentService,
    private duelSeriesService: DuelSeriesService,
  ) { }

  ngOnInit(): void {
    this.playersService.getPlayerVideo().subscribe((response) => {
      this.duelsWithVideoByTournaments = response;
      this.setTournamentsName();
      this.setDuelsInfo();
    });
  }

  get duelsWithVideoByTournaments() {
    return this._duelsWithVideoByTournaments;
  }

  set duelsWithVideoByTournaments(object) {
    this._duelsWithVideoByTournaments = object;
  }

  getDuelsAndTournaments() {
    return this.duelsWithVideoByTournaments.ds_with_video;
  }

  get tournamentsName() {
    return this._tournamentsName;
  }

  set tournamentsName(object) {
    this._tournamentsName = object;
  }

  setTournamentsName() {
    for (var tournament in this.getDuelsAndTournaments()) {
      var res;
      this.tournamentService.get(Number(tournament)).subscribe((response) => {
        res = response;
        this.tournamentsName[res.id] = res.name;
      });
    }
  }

  getTournamentName(tournamentId) {
    return this.tournamentsName[tournamentId];
  }

  getAllTournaments() {
    var arrayTournaments = [];
    for (var tournament in this.getDuelsAndTournaments()) {
      arrayTournaments.push(tournament);
    }
    return arrayTournaments;
  }

  getDuelsForTournament(tournamentId) {
    var dataArray = this.getDuelsAndTournaments();
    return dataArray[tournamentId];
  }

  get duelsInfo() {
    return this._duelsInfo;
  }

  set duelsInfo(object) {
    this._duelsInfo = object;
  }

  setDuelsInfo() {
    var data = this.getDuelsAndTournaments();
    for (var tournament in data) {
      data[tournament].forEach(duel => {
        this.duelSeriesService.get(Number(duel)).subscribe((response) => {
          var res;
          res = response;
          this.duelsInfo[res.id] = {
            'number': res?.number,
            'player_one': res?.player_one?.full_name,
            'player_one_score': res?.player_one_score,
            'player_two': res?.player_two?.full_name,
            'player_two_score': res?.player_two_score,
            'youtube_link': res?.youtube_link,
            'status': res?.status
          };
        });
      });
    }
  }

  backToPlayerModal() {
    this.outputClickOnBack.emit();
  }

  getPlayerWinner(duel) {
    return (duel.player_one_score > duel.player_two_score) ? duel.player_one : duel.player_two;
  }

  getPlayerLooser(duel) {
    return (duel.player_one_score > duel.player_two_score) ? duel.player_two : duel.player_one;
  }

  getPlayerWinnerScore(duel) {
    return (duel.player_one_score > duel.player_two_score) ? duel.player_one_score : duel.player_two_score;
  }

  getPlayerLooserScore(duel) {
    return (duel.player_one_score > duel.player_two_score) ? duel.player_two_score : duel.player_one_score;
  }

  duelIsFinished(duel) {
    return duel.status == "finished";
  }

  winnerStyle(duel) {
    return this.duelIsFinished(duel)
      ? 'scoreCell winnerScoreCell'
      : 'scoreCell defeatedCell';
  }

}
